export default "__VITE_ASSET__CmdPPUMw__"